/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Mistral_FooterInputs */

const en_landing_mistral_footer = /** @type {(inputs: Landing_Mistral_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI processing by Mistral · Paris, France · EU data residency`)
};

const de_landing_mistral_footer = /** @type {(inputs: Landing_Mistral_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Verarbeitung durch Mistral · Paris, Frankreich · EU-Datenresidenz`)
};

const fr_landing_mistral_footer = /** @type {(inputs: Landing_Mistral_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement IA par Mistral · Paris, France · Résidence des données dans l'UE`)
};

const es_landing_mistral_footer = /** @type {(inputs: Landing_Mistral_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesamiento IA por Mistral · París, Francia · Residencia de datos en la UE`)
};

const it_landing_mistral_footer = /** @type {(inputs: Landing_Mistral_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elaborazione AI di Mistral · Parigi, Francia · Residenza dati UE`)
};

const nl_landing_mistral_footer = /** @type {(inputs: Landing_Mistral_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-verwerking door Mistral · Parijs, Frankrijk · EU-dataresidentie`)
};

const pl_landing_mistral_footer = /** @type {(inputs: Landing_Mistral_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przetwarzanie AI przez Mistral · Paryż, Francja · Rezydencja danych w UE`)
};

const fi_landing_mistral_footer = /** @type {(inputs: Landing_Mistral_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekoälykäsittely: Mistral · Pariisi, Ranska · EU-dataresidenssi`)
};

const da_landing_mistral_footer = /** @type {(inputs: Landing_Mistral_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-behandling af Mistral · Paris, Frankrig · EU-dataopbevaring`)
};

const sv_landing_mistral_footer = /** @type {(inputs: Landing_Mistral_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-bearbetning av Mistral · Paris, Frankrike · EU-dataresidency`)
};

/**
* | output |
* | --- |
* | "AI processing by Mistral · Paris, France · EU data residency" |
*
* @param {Landing_Mistral_FooterInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_mistral_footer = /** @type {((inputs?: Landing_Mistral_FooterInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Mistral_FooterInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_mistral_footer(inputs)
	if (locale === "fr") return fr_landing_mistral_footer(inputs)
	if (locale === "es") return es_landing_mistral_footer(inputs)
	if (locale === "it") return it_landing_mistral_footer(inputs)
	if (locale === "nl") return nl_landing_mistral_footer(inputs)
	if (locale === "pl") return pl_landing_mistral_footer(inputs)
	if (locale === "fi") return fi_landing_mistral_footer(inputs)
	if (locale === "da") return da_landing_mistral_footer(inputs)
	if (locale === "sv") return sv_landing_mistral_footer(inputs)
	return en_landing_mistral_footer(inputs)
});